import { VerticalSeparator } from 'components/VerticalSeparator'
import { styled } from 'stitches.config'

export const StackContainer = styled('div', {
  py: '$2',
  position: 'relative',
  order: 1,

  '@bp2': {
    position: 'initial',
    top: 0,
    py: '$8',
    height: '100%',
    order: 'initial',
  },

  variants: {
    variant: {
      default: {
        top: '-$8',
      },
      foodForDigestiveIssues: {
        top: '-$9',
      },
    },
  },

  defaultVariants: {
    variant: 'default',
  },
})

export const CustomVerticalSeparator = styled(VerticalSeparator, {
  height: '$8 !important',
  margin: 'auto',
  marginTop: '$2',
  order: 1,
  marginBottom: '$2',

  '@bp2': {
    width: '1px',
    margin: 'initial',
    height: 'auto !important',
    marginLeft: '$2',
    order: 'initial',
    marginBottom: '0',
  },

  variants: {
    reversed: {
      true: {
        '@bp2': {
          order: 2,
          marginLeft: 0,
          marginRight: '$2',
        },
      },
    },
  },
})

export const TextContainer = styled('div', {
  order: 2,
  paddingTop: 0,
  '@bp2': { paddingTop: '$6', order: 'initial' },
})

export const TextWrapper = styled('div', {

  '& > div > div': {
    flexDirection: 'column',
  },

  '@bp2': {
    '& > div > div': {
      flexDirection: 'row',
    },
  },

  variants: {
    order: {
      'low': {
        order: 1,
        '@bp2': {
          order: 1,
        }
      },
      'high': {
        order: 1,
        '@bp2': {
          order: -1,
        }
      },
    }
  },

  defaultVariants: {
    order: 'high'
  }
})